sn-rating-type-2 {
  .rating-type-2 {
    margin-top: var(--spacing-4xl);
    padding: 0;
    background: none;
    border: none;
  }
}
